
<template>
  <div>
    <div class="find">
      <div class="seach-top">
        <el-form
          ref="searchForm"
          :inline="true"
          :model="searchForm"
          class="demo-form-inline"
        >
          <el-form-item>
            <el-input
              v-model="searchForm.keyWord1"
              style="width:140px"
              placeholder="手机号/邮箱"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchForm.keyWord2"
              style="width:120px"
              placeholder="姓名/标签"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchForm.keyWord3"
              placeholder="单位/部门/科室/职务"
              style="width:250px"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-input
              v-model="searchForm.keyWord4"
              style="width:200px"
              placeholder="其他"
              size="small"
              clearable
            />
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="handleSearch"
            >
              查询
            </el-button>
          </el-form-item>
          <div
            class="btn-box"
            style="float: right;"
          >
            <el-form-item>
              <el-button
                style="margin-left: 8px"
                size="small"
                type="primary"
                @click="handleExport()"
              >
                导出
                <i class="el-icon-download el-icon--right" />
              </el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>

    <el-table
      class="table-list"
      :border="true"
      :data="tableData"
      style="width: 100%"
      @sort-change="handleResort"
    >
      <!-- 姓名 -->
      <el-table-column
        prop="userName"
        label="姓名"
        width="120"
        sortable="custom"
      >
        <template slot-scope="scope">
          <div>
            <el-button
              type="text"
              size="small"
              @click.native.prevent="handleToView(scope.row.id)"
            >
              {{ scope.row.userName }}
            </el-button>
          </div>
        </template>
      </el-table-column>

      <!-- 手机号码 -->
      <el-table-column
        prop="phoneNumber"
        label="手机号码"
        width="120"
        sortable="custom"
      />

      <!-- 电子邮箱 -->
      <el-table-column
        prop="emailAddress"
        label="电子邮箱"
        width="150"
        sortable="custom"
      />
      <el-table-column label="共同课题组" width="200px" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.comTeams.length>0">{{ scope.row.comTeams[0].showName }}</el-tag>
          <el-popover placement="right" width="400" trigger="hover">
            <el-table :data="scope.row.comTeams" :show-header="false" width="100%">
              <el-table-column width="150" property="danWeiInfo.danWeiMingCheng" label="单位名称" />
              <el-table-column min-width="100" property="showName" label="课题组">
                <template slot-scope="sc1">
                  <el-button type="text" @click="handleToTd02(sc1.row)">{{ sc1.row.showName }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-tag v-if="scope.row.comTeams.length>1" slot="reference">...</el-tag>
          </el-popover>
        </template>
      </el-table-column>

      <!-- 标签 -->
      <el-table-column
        prop="userName2"
        label="标签"
        width="300"
      >
        <template slot-scope="scope">
          <el-tag
            v-for="(tag,index) in getTags(scope.row.userName2)"
            :key="index"
            closable
            :disable-transitions="false"
            @close="handleClose(scope.row,tag)"
          >
            {{ tag }}
          </el-tag>
          <el-select
            v-if="scope.row.isTagInputVisible"
            :ref="'saveTagInput-'+scope.row.id"
            v-model="scope.row.selTags"
            multiple
            filterable
            allow-create
            default-first-option
            placeholder="请选择标签"
            @change="handleTagChange(scope.row)"
            @blur="handleTagBlur(scope.row)"
            @focus="handleTagFocus(scope.row)"
          >
            <el-option
              v-for="item in tagOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button v-else class="button-new-tag" size="small" @click="showInput(scope.row)">+</el-button>
        </template>
      </el-table-column>

      <!-- 性别 -->
      <el-table-column
        prop="sexDictKeyItemName"
        label="性别"
        width="80"
        sortable="custom"
        align="center"
      />

      <!-- 单位名称 -->
      <el-table-column
        :show-overflow-tooltip="true"
        prop="danWeiMingCheng"
        label="单位名称"
        width="150"
        sortable="custom"
      />

      <!-- 部门 -->
      <el-table-column
        prop="buMen"
        label="部门"
        width="120"
        sortable="custom"
        :show-overflow-tooltip="true"
      />

      <!-- 科室 -->
      <el-table-column
        prop="keShi"
        label="科室"
        width="120"
        sortable="custom"
        :show-overflow-tooltip="true"
      />

      <!-- 职务 -->
      <el-table-column prop="zhiWu" label="职务" width="120" sortable="custom" />
      <el-table-column prop="zhiCheng" label="职称" width="120" sortable="custom" />

      <!-- 学位 -->
      <el-table-column prop="xueWeiDictIdItemName" label="学位" width="120" sortable="custom" />
      <!-- 学科 -->
      <el-table-column prop="suoShuXueKe" label="学科" width="120" sortable="custom" />
      <!-- 专业 -->
      <el-table-column prop="zhuanYe" label="专业" width="120" sortable="custom" />

      <!-- 研究领域 -->
      <el-table-column prop="yanJiuLingYu" label="研究领域" width="150" sortable="custom" :show-overflow-tooltip="true" />

      <!-- 研究方向 -->
      <el-table-column prop="yanJiuFangXiang" label="研究方向" width="150" sortable="custom" :show-overflow-tooltip="true" />

      <el-table-column
        fixed="right"
        label="操作"
        width="200"
        align="center"
      >
        <template slot-scope="scope">
          <span>
            <el-button
              v-if="scope.row.friendUserId"
              type="text"
              size="small"
              @click="handleCancelFriend(scope.row)"
            >
              取消好友
            </el-button>
            <el-button
              v-if="scope.row.friendUserId"
              type="text"
              size="small"
              @click="handleViewResume(scope.row)"
            >
              简历
            </el-button>
          </span>
          <el-button style="margin-left:10px" size="mini" type="primary" @click="handleSendMsg(scope.row)">私信</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="prev, pager, next,total,sizes"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="10"
      :total="totalCount"
      @size-change="handleSizeChange"
      @current-change="handleChangePage"
    />
    <!-- 简历展示 -->
    <Resume
      v-model="resumeShow"
      :resume-user-id="resumeUserId"
      :resume-key="resumeKey"
    />
    <SendMsg ref="sendmsg" />
  </div>
</template>

<script>
import pathReq from '@/api/pathlist'
import KxjCom from '@/utils/kxjcom'
import Resume from '@/components/Resume'
import SendMsg from '@/views/managesystem/gz/com/MemberSendMsg'

export default {
  components: {
    Resume, SendMsg
  },
  filters: {
    dateFmt(val) {
      return KxjCom.tableDateFormat(val)
    },
    decFmt(val) {
      return KxjCom.tableDecFormat(val)
    }
  },
  props: {},
  data() {
    return {
      title: '我的好友',
      totalCount: 0,
      tableData: [],
      allComboxData: [],
      searchForm: {
        keyWord: '',
        pageNumber: 1,
        pageSize: 10,
        sortKey: '',
        sortOrder: ''
      },
      // 简历数据
      resumeShow: false,
      resumeUserId: null,
      resumeKey: null,
      // 标签
      inputVisible: false,
      inputValue: '',
      tagOptions: [],
      selTags: []

    }
  },
  computed: {},
  watch: {},
  created() {
    this.$bus.on('FriendSearch1', this.handleSearch)
  },
  mounted() { },
  methods: {
    // combox筛选值
    getComboxData(typeId) {
      return this.allComboxData.filter(function(item) {
        return item.typeId === typeId
      })
    },
    // 每页
    handleSizeChange(val) {
      this.searchForm.pageSize = val
      this.handleSearch()
    },
    // 切页
    handleChangePage(page) {
      this.searchForm.pageNumber = page
      this.handleSearch()
    },
    // 排序
    handleResort(column) {
      this.searchForm.sortKey = column.prop
      this.searchForm.sortOrder = column.order
      this.handleSearch()
    },
    // 查询
    handleSearch() {
      const that = this
      const loading = this.$loading(KxjCom.loadOptions)

      pathReq.getList('/api/services/app/Contact/GetAllFriendTags')
        .then(res => {
          that.tagOptions = []
          res.data.result.forEach(element => {
            that.tagOptions.push({
              value: element,
              label: element
            })
          })
        }).then(_ => {
          const path = '/api/services/app/Contact/GetPagedListContacts1'
          pathReq
            .getList(path, that.searchForm)
            .then(res => {
              loading.close()
              that.totalCount = res.data.result.totalCount
              that.tableData = res.data.result.items
            })
        })
    },
    // 取消好友
    handleCancelFriend(row) {
      const that = this
      console.log(row)
      this.$confirm('确定要取消好友吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const path = '/api/services/app/Contact/CancelFriend'
        pathReq
          .postForm(path, {
            id: row.id,
            friendUserId: row.friendUserId
          })
          .then(res => {
            if (res.status === 200) {
              if (res.data.success) {
                this.$message.success('取消好友成功!')
                that.handleSearch()
                this.$bus.emit('FriendSearch2')
              } else {
                this.$message.error('取消好友失败!')
              }
            }
          })
      })
    },
    /** 查看简历 */
    handleViewResume(row) {
      this.resumeUserId = row.systemUserId
      this.resumeShow = true
    },
    // 导出
    handleExport() {
      this.downloadLoading = true
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          '手机号码',
          '电子邮箱',
          '姓名',
          '别名',
          '性别',
          '单位名称',
          '部门',
          '科室',
          '职务',
          '学位',
          '研究领域',
          '研究方向'
        ]
        const filterVal = [
          'phoneNumber',
          'emailAddress',
          'userName',
          'userName2',
          'sexDictKeyItemName',
          'danWeiMingCheng',
          'buMen',
          'keShi',
          'zhiWu',
          'xueWeiDictIdItemName',
          'yanJiuLingYu',
          'yanJiuFangXiang'
        ]
        const list = this._data.tableData
        const data = KxjCom.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: '我的好友', // 非必填
          autoWidth: true, // 非必填
          bookType: 'xlsx' // 非必填
        })
        this.downloadLoading = false
      })
    },
    /** 详情 */
    handleToView(id) {
      this.$router.push({ name: 'contactview', params: { id: id }})
    },

    /** 取得标签 */
    getTags(str) {
      if (!str) {
        return []
      } else {
        return str.split(',')
      }
    },
    /** 删除标签 */
    handleClose(row, tag) {
      const that = this
      const path = '/api/services/app/Contact/DelTag'
      pathReq
        .postForm(path, {
          id: row.id,
          newTagVal: tag
        }).then(_ => {
          that.handleSearch()
        })
    },
    /** 展示显示标签输入框 */
    showInput(row) {
      row.isTagInputVisible = true
      const that = this
      var refKey = 'saveTagInput-' + row.id
      this.$nextTick(_ => {
        that.$refs[refKey].$refs.input.focus()
      })
    },
    /** 确认保存标签 */
    handleInputConfirm(row) {
      const that = this
      const path = '/api/services/app/Contact/AddTag'
      pathReq
        .postForm(path, {
          id: row.id,
          newTagVal: row.newTagVal
        }).then(_ => {
          that.handleSearch()
        })
    },
    /** 修改标签 */
    handleTagChange(row) {
      const that = this
      row.selTags.forEach(ele => {
        var exist = that.tagOptions.find(i => i.value === ele)
        if (!exist) {
          that.tagOptions.push({
            value: ele,
            label: ele
          })
        }
      })

      row.userName2 = row.selTags.join(',')
      const path = '/api/services/app/Contact/ResetTag'
      pathReq.postForm(path, row).then(_ => {
        // that.handleSearch()
        row.isTagInputVisible = false
      })
    },
    handleTagBlur(row) {
      this.$notify({ title: 'aaa' })
      row.isTagInputVisible = false
    },
    handleTagFocus(row) {
      var refKey = 'saveTagInput-' + row.id
      this.$refs[refKey].$refs.input.blur = (row) => {
        row.isTagInputVisible = false
      }
    },
    /** 跳转到科研团队页面 */
    handleToTd02(row) {
      this.$router.push({
        name: 'td02',
        params: {
          danWeiBuMenKey: row.id
        }
      })
    },
    /** 私信 */
    handleSendMsg(row) {
      this.$refs.sendmsg.showDialog(row.friendUserId, row.friendUserName)
    }

  }
}
</script>

<style scoped>
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>
